/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/ChallengeStartModal',['pixi', 'absolute', 'lodash', 'MenuUI/MsftButton', 'MenuUI/MsftRectButton', 'MenuUI/ControlFocusManager',
    'absolute/stringmanager', 'util/NineSliceButton', 'Managers/ScaleManager', 'MenuUI/ChallengeFooter', 'Managers/TelemetryManager'],

    function (PIXI, Absolute, _, MsftButton, MsftRectButton, ControlFocusManager, StringManager, NineSliceButton,
        ScaleManager, ChallengeFooter, TelemetryManager) {

        var ChallengeStartModal = function (parent, game, config, footer, isRestart) {
            PIXI.DisplayObjectContainer.call(this);
            this.parentToAdd = parent;
            this.game = game;
            this.config = config;
            this.challengeFooter = footer;
            this.isRestart = isRestart;
            this.initModal();
            parent.addChild(this);
            this.initBkg();
            this.initRibbon();
            this.initInfo();
            this.initButtons();
            this.initForceScaleSprite();
            ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
        };

        var ColorConstants = {
            Klondike: {right: "#1b9ecb", left: "#48cffd"},
            Spider: {right: "#9757ce", left: "#d5a4ff"},
            FreeCell: {right: "#d62c29", left: "#ff7070"},
            Pyramid: {right: "#d98a01", left: "#fb9a00"},
            TriPeaks: {right: "#79b31b", left: "#8ac91d"}
        };

        ChallengeStartModal.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        ChallengeStartModal.prototype.initModal = function () {
            this.modal = new PIXI.Graphics();
            this.modal.beginFill(0x000000);
            this.modal.drawRect(0, 0, Absolute.Coords.x(10000), Absolute.Coords.y(10000));
            this.modal.alpha = 0.8;
            this.modal.interactive = true;
            this.bindModalInput();
            this.parentToAdd.addChild(this.modal);

            this.controlFocusManager = new ControlFocusManager();
        };

        ChallengeStartModal.prototype.bindModalInput = function () {
            this.modal.mouseover = function (evt) {
            };
            this.modal.mouseout = function (evt) {
            };
            this.modal.mousedown = function (evt) {
            };
            this.modal.mouseup = function (evt) {
            };
            this.modal.touchstart = function (evt) {
            };
            this.modal.touchend = function (evt) {
            };
            this.modal.touchendoutside = function (evt) {
            };
        };

        ChallengeStartModal.prototype.initBkg = function () {
            this.bodyGroup = new PIXI.DisplayObjectContainer();
            this.bottomHalf = PIXI.Sprite.fromFrame("challenge_start/bkg_bottom.png");
            this.topHalf = PIXI.Sprite.fromFrame("challenge_start/bkg_top.png");
            this.bottomHalf.position.set(0, Absolute.Coords.y(70));
            this.addChild(this.topHalf);
            this.addChild(this.bodyGroup);
            this.bodyGroup.addChild(this.bottomHalf);
            var topMask = new PIXI.Graphics(),
                bottomMask = new PIXI.Graphics();
            this.addChild(topMask);
            this.addChild(bottomMask);
            topMask.beginFill(0xfff333);
            topMask.drawRect(0, 0, this.topHalf.width, this.topHalf.height);
            topMask.endFill();
            bottomMask.beginFill(0x333fff);
            bottomMask.drawRect(0, Absolute.Coords.y(70), this.bottomHalf.width, this.bottomHalf.height);
            bottomMask.endFill();
            this.topHalf.mask = topMask;
            this.bodyGroup.mask = bottomMask;
        };

        ChallengeStartModal.prototype.initRibbon = function () {
            this.ribbonGroup = new PIXI.DisplayObjectContainer();
            var gameName = this.config.gameName;
            var rightHex = ColorConstants[gameName].right,
                leftHex = ColorConstants[gameName].left;
            this.addChild(this.ribbonGroup);
            var leftCorner = new PIXI.Sprite.fromFrame("challenge_start/banner_" + gameName + "_left_corner.png"),
                rightCorner = new PIXI.Sprite.fromFrame("challenge_start/banner_" + gameName + "_right_corner.png");
            this.ribbonGroup.addChild(leftCorner);
            this.ribbonGroup.addChild(rightCorner);
            leftCorner.position.set(Absolute.Coords.x(-17), Absolute.Coords.y(80));
            rightCorner.position.set(Absolute.Coords.x(955), Absolute.Coords.y(80));
            var ribbonGraphics = new PIXI.Graphics();
            this.ribbonGroup.addChild(ribbonGraphics);
            ribbonGraphics.beginFill(parseInt(leftHex.replace('#', ''), 16), 1);
            ribbonGraphics.drawRect(Absolute.Coords.x(-17), Absolute.Coords.y(25),
                Absolute.Coords.x(270), Absolute.Coords.y(55));
            ribbonGraphics.endFill();
            ribbonGraphics.beginFill(parseInt(rightHex.replace('#', ''), 16), 1);
            ribbonGraphics.drawRect(Absolute.Coords.x(253), Absolute.Coords.y(25),
                Absolute.Coords.x(720), Absolute.Coords.y(55));
            ribbonGraphics.endFill();
            ribbonGraphics.beginFill(0x000000, .3);
            ribbonGraphics.drawRect(Absolute.Coords.x(2), Absolute.Coords.y(80),
                Absolute.Coords.x(953), Absolute.Coords.y(4));
            ribbonGraphics.endFill();
            this.ribbonLeftCorner = leftCorner;
            this.ribbonRightCorner = rightCorner;
        };

        ChallengeStartModal.prototype.initInfo = function () {
            var gameLabel, gameIcon, descriptionLabel, difficultyLabel,
                difficultyTypeLabel, rewardLabel, rewardTypeIcon, rewardTypeLabel, config, textStyle;
            config = this.config;
            textStyle = {
                font: Absolute.ScreenMetrics.getResScale() * 31 + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff'
            };
            gameLabel = new PIXI.Text(config.gameName, textStyle);
            gameIcon = new PIXI.Sprite.fromFrame('icon_' + (config.gameName).toLowerCase() + '_topUI.png');
            descriptionLabel = new PIXI.Text(config.gameDescription, {
                font: Absolute.ScreenMetrics.getResScale() * 31 + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff'
            });
            Absolute.StringManager.shrinkToFit(descriptionLabel, 31, '', Absolute.Coords.x(650), Absolute.Coords.y(55));
            difficultyLabel = new PIXI.Text(Absolute.StringManager('kickoff.difficulty') + ':', textStyle);
            difficultyTypeLabel = new PIXI.Text(Absolute.StringManager(config.difficultyName), {
                font: Absolute.ScreenMetrics.getResScale() * 31 + "px Arial",
                fontFamily: 'segoe',
                fill: ColorConstants[config.gameName].right
            });

            rewardLabel = new PIXI.Text(Absolute.StringManager('kickoff.reward') + ':', textStyle);
            rewardTypeIcon = new PIXI.Sprite.fromFrame(config.rewardIcon);
            rewardTypeIcon.scale.set(0.65, 0.65);
            var rewardLabelText = (config.isCompleted) ? Absolute.StringManager('dialogs.alreadyEarned') :
                config.rewardAmount + " " + Absolute.StringManager(config.rewardType);
            rewardTypeLabel = new PIXI.Text(rewardLabelText, textStyle);

            this.ribbonGroup.addChild(gameLabel);
            this.ribbonGroup.addChild(gameIcon);
            this.ribbonGroup.addChild(descriptionLabel);

            gameLabel.position.set(Absolute.Coords.x(30), Absolute.Coords.y(35));
            gameIcon.position.set(Absolute.Coords.x(200), Absolute.Coords.y(50));
            gameIcon.anchor.set(.5, .5);
            descriptionLabel.position.set(Absolute.Coords.x(265), Absolute.Coords.y(35));


            this.bodyGroup.addChild(difficultyLabel);
            this.bodyGroup.addChild(difficultyTypeLabel);
            this.bodyGroup.addChild(rewardLabel);
            this.bodyGroup.addChild(rewardTypeLabel);
            this.bodyGroup.addChild(rewardTypeIcon);
            difficultyLabel.anchor.set(1, 0);
            rewardLabel.anchor.set(1, 0);
            difficultyLabel.position.set(Absolute.Coords.x(460), Absolute.Coords.y(150));
            rewardLabel.position.set(Absolute.Coords.x(460), Absolute.Coords.y(200));
            difficultyTypeLabel.position.set(Absolute.Coords.x(470), Absolute.Coords.y(150));
            rewardTypeLabel.position.set(Absolute.Coords.x(520), Absolute.Coords.y(200));
            rewardTypeIcon.position.set(Absolute.Coords.x(490), Absolute.Coords.y(220));
            rewardTypeIcon.anchor.set(.5, .5);
        };

        ChallengeStartModal.prototype.initButtons = function () {
            var labelOptions = {
                font: Absolute.ScreenMetrics.getResScale() * 31 + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff',
                align: 'left',
                anchor: {
                    x: 0.5,
                    y: 0.5
                },
                x: Absolute.Coords.x(0),
                y: Absolute.Coords.y(3)
            };
            this.playButton = new NineSliceButton(
                'warning_dialogues/popup_button_Play_click.png',
                'warning_dialogues/popup_button_Play_over.png', 'warning_dialogues/popup_button_Play.png',
                Absolute.Coords.x(270), Absolute.Coords.y(100), 25, 25, 25, 25, Absolute.StringManager('buttons.play'), labelOptions);
            this.closeButton = new NineSliceButton(
                'warning_dialogues/popup_button_Cancel_click.png',
                'warning_dialogues/popup_button_Cancel_over.png', 'warning_dialogues/popup_button_Cancel.png',
                Absolute.Coords.x(270), Absolute.Coords.y(100), 25, 25, 25, 25, Absolute.StringManager('buttons.cancel'), labelOptions);
            this.bodyGroup.addChild(this.playButton);
            this.bodyGroup.addChild(this.closeButton);
            this.playButton.position.set(Absolute.Coords.x(340), Absolute.Coords.y(352));
            this.closeButton.position.set(Absolute.Coords.x(620), Absolute.Coords.y(352));
            this.playButton.anchor.set(.5, .5);
            this.closeButton.anchor.set(.5, .5);
            this.playButton.onClick.add(function () {
                // Deal new game
                Absolute.AudioManager.playSound('button');
                
                var challenge = this.game.solitaire.CurrentChallenge;
                if (challenge.config.Date) {
                    var date = new Date(parseInt(challenge.config.Date.substring(6, 19)));
                    var formattedDate = (date.getMonth() + 1) + '/' + date.getDate() + '/'
                        + date.getFullYear();

                    TelemetryManager.challengeStart(
                        formattedDate, challenge.config.Data.GameMode, this.isRestart, challenge.config.Difficulty);
                } else {
                    TelemetryManager.starClubStart(challenge.config.Data.GameMode);
                }

                this.game.solitaire.DealNewGame();
                this.game.solitaire.Authority.CardSupply.IsWaitingForAds = false;
                this.playButton.interactive = false;
                this.closeButton.interactive = false;
                this.playButton.alpha = .5;
                this.closeButton.alpha = .5;
                this.doAnimation();
            }.bind(this));
            this.closeButton.onClick.add(function () {
                    Absolute.AudioManager.playSound('button');
                    this.game.navBack();
                    this.destroy();
            }.bind(this));

            this.controlFocusManager.addControl(this.playButton, true, null, 0);
            this.controlFocusManager.addControl(this.closeButton, true, null, 1);

            this.controlFocusManager.unfocusCurrentControl();
            this.controlFocusManager.focusCurrentControl();
        };

        ChallengeStartModal.prototype.doAnimation = function () {

            if (this.game && this.game.gameScreenUI)
                this.game.gameScreenUI.challengeStartModal = null;

            var topHalf = this.topHalf, modal = this.modal,
                bodyGroup = this.bodyGroup,
                destroy = this.destroy.bind(this),
                showFooter = this.showFooter.bind(this),
                self = this;

            var fadeTween = new TWEEN.Tween({alpha: 1})
                .to({alpha: 0}, 300)
                .easing(TWEEN.Easing.Linear.None)
                .onUpdate(function () {
                    self.alpha = this.alpha;
                    if (this.alpha <= modal.alpha) modal.alpha = this.alpha;
                })
                .onComplete(function () {
                    destroy();
                    showFooter();
                });
            var topTween = new TWEEN.Tween({y: 0})
                .to({y: Absolute.Coords.y(100)}, 800)
                .easing(TWEEN.Easing.Linear.None)
                .onUpdate(function () {
                    topHalf.y = this.y;
                })
                .onComplete(function () {
                    topBg.visible = false;
                    fadeTween.start();
                })
                .start();
            var bodyTween = new TWEEN.Tween({y: 0})
                .to({y: Absolute.Coords.y(-500)}, 700)
                .easing(TWEEN.Easing.Linear.None)
                .onUpdate(function () {
                    bodyGroup.y = this.y;
                })
                .onComplete(function () {
                    body.visible = false;
                })
                .start();
            var left = this.ribbonLeftCorner, right = this.ribbonRightCorner,
                topBg = this.topHalf, body = this.bodyGroup;
            var ribbonCornerTween = new TWEEN.Tween({y: Absolute.Coords.y(80)})
                .to({y: Absolute.Coords.y(60)}, 400)
                .easing(TWEEN.Easing.Linear.None)
                .onUpdate(function () {
                    left.y = this.y;
                    right.y = this.y;
                })
                .onComplete(function () {
                    left.visible = false;
                    right.visible = false;
                })
                .start();
        };

        ChallengeStartModal.prototype.showFooter = function () {
            this.challengeFooter.appear();
        };

        ChallengeStartModal.prototype.destroy = function () {
            ScaleManager.removeElement(this);
            this.parentToAdd.removeChild(this);
            this.parentToAdd.removeChild(this.modal);
        };

        ChallengeStartModal.prototype.initForceScaleSprite = function () {
            this.forceScaleSprite = PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Up.png");
            this.forceOffsetX = Absolute.Coords.x(80);
            this.forceOffsetY = Absolute.Coords.y(50);

            if (Absolute.Platform.isMobile() && Absolute.ScreenMetrics.isPortrait()) {
                this.forceOffsetY = Absolute.Coords.y(0);
            }
            
            this.forceScaleSprite.width = Absolute.Coords.x(1020);
            this.forceScaleSprite.height = Absolute.Coords.y(465);
            this.forceScaleSprite.alpha = 0;
            this.addChild(this.forceScaleSprite);
        };

        ChallengeStartModal.prototype.handleResize = function () {
            if (this.parent) this.updateTransform();
            var oldScaleX = this.scale.x, oldScaleY = this.scale.y;
            this.scale.set(1, 1);
            var initialWidth = this.width, initialHeight = this.height;
            this.scale.set(oldScaleX, oldScaleY);
            var screenScaleX = Absolute.Coords.x(1920) / ScaleManager.width,
                screenScaleY = Absolute.Coords.y(1080) / ScaleManager.height,
                roomWidth = ScaleManager.width, roomHeight = ScaleManager.height;
            this.width = initialWidth * screenScaleX;
            this.height = initialHeight * screenScaleY;
            var realWidth = this.width / screenScaleX, realHeight = this.height / screenScaleY;
            var widthToShow = initialWidth, heightToShow = initialHeight;
            var tookCare = false;
            if (realWidth > roomWidth) {
                this.width = Absolute.Coords.x(1920);
                var delta = roomWidth / widthToShow;
                this.height = ((initialHeight * screenScaleY) * delta);
                if ((this.height / screenScaleY) > roomHeight) {
                    this.height = Absolute.Coords.y(1080);
                    var delta = roomHeight / heightToShow;
                    this.width = ((initialWidth * screenScaleX) * delta);
                }
                tookCare = true;
            }
            if (!tookCare && (realHeight > roomHeight)) {
                this.height = Absolute.Coords.y(1080);
                var delta = roomHeight / heightToShow;
                this.width = ((initialWidth * screenScaleX) * delta);
                if ((this.width / screenScaleX) > roomWidth) {
                    this.width = Absolute.Coords.x(1920);
                    var delta = roomWidth / widthToShow;
                    this.height = ((initialHeight * screenScaleY) * delta);
                }
            }
            this.x = (Absolute.Coords.x(1920) * .5) - (this.width / 2) + this.forceOffsetX;
            this.y = (Absolute.Coords.y(1080) * .5) - (this.height / 2) + this.forceOffsetY;
        };

        ChallengeStartModal.prototype.handleCommand = function (command) {
            switch (command) {
                case 'Tab':
                case 'Right':
                    this.controlFocusManager.focusNextControl(1);
                    break;
                case 'ShiftTab':
                case 'Left':
                    this.controlFocusManager.focusNextControl(-1);
                    break;
                case 'Activate':
                    this.controlFocusManager.activateCurrentControl();
                    break;

            }
        };

        return ChallengeStartModal;
    });

